import axios, { AxiosRequestConfig } from 'axios';
import getApiHostName from './utils/getApiHostName';
import Options from './utils/Options';
import buildException from './utils/buildException';

const excludedMessages = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications.',
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function error(level: string, errorObj: any, message: string = null, details: any = null, id: string = null, correlationId: string = null): void {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument
  if (errorObj && excludedMessages.indexOf(errorObj.messageOrEvent) > -1) return;
  const entity = buildException(level, errorObj, message, details, id, correlationId);
  const requestConfig: AxiosRequestConfig = {};
  requestConfig.data = Options.Instance();
  // eslint-disable-next-line no-void
  void axios.post(`${getApiHostName()}/exception`, entity, requestConfig);
}
